import { render, staticRenderFns } from "./PodtEditAbout.vue?vue&type=template&id=110f4d98&scoped=true&"
import script from "./PodtEditAbout.vue?vue&type=script&lang=js&"
export * from "./PodtEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f4d98",
  null
  
)

export default component.exports